import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy} from '@angular/core';

// This component clips the projected component to show only a preview
// Jira task: https://testfabrik.atlassian.net/browse/WMKNBN-11512
@Component({
  selector: 'wm-clipping-window',
  standalone: true,
  imports: [],
  templateUrl: './clipping-window.component.html',
  styleUrl: './clipping-window.component.less'
})
export class ClippingWindowComponent implements AfterViewInit, OnDestroy {
    @Input() fitToGrandParent: boolean = false;

    private resizeObserver?: ResizeObserver;
    parentWidth: number = 100;
    parentHeight: number = 100;

    constructor(private elementRef: ElementRef, private cdr: ChangeDetectorRef) {
    }

    ngAfterViewInit(): void {
        const parentElement = this.elementRef.nativeElement.parentElement;
        if (parentElement) {
            this.onParentResize();
            this.resizeObserver = new ResizeObserver((entries) => {
                for (const _ of entries) {
                    this.onParentResize();
                }
            });
            this.resizeObserver.observe(parentElement);
        }
    }

    ngOnDestroy(): void {
        this.resizeObserver?.disconnect();
    }

    onParentResize() {
        const rectSize = this.elementRef.nativeElement.parentElement.getBoundingClientRect();
        this.parentWidth = rectSize.width;
        if (this.fitToGrandParent) {
            this.parentHeight = rectSize.height;
        }
        this.cdr.detectChanges();
    }

}
